export default "__VITE_ASSET__Bgy$l0or__"